export enum TrackingPixelVendor {
  IFRAME = 'iframe',
  IMAGE = 'image',
  TRADE_DESK = 'trade-desk',
  YAHOO_DOT = 'yahoo-dot',
}
